import { useEffect, useRef, useState } from 'react';

import { IframeSkeleton } from '@web/blocks/authenticated-iframe-block/iframe-skeleton/iframe-skeleton';

export function JoblogIframe({ source, title }: { source: string; title: string }) {
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const [iframeLoading, setIframeLoading] = useState(true);
	const [height, updateHeight] = useState('100%');

	useEffect(() => {
		if (!window) {
			return;
		}

		function handler(evt: MessageEvent<`size:${number}${number}`>) {
			if (!source.includes(evt.origin)) {
				return;
			}

			if (evt.data.startsWith('size:')) {
				// format is: `size:${Height},${Width}` for some reason.
				const [newHeight] = evt.data.replace('size:', '').split(',');

				return updateHeight(`${newHeight}px`);
			}

			// eslint-disable-next-line no-console
			console.debug('Missing handler:', { data: evt.data });
		}

		window.addEventListener('message', handler);

		return () => {
			window.removeEventListener('message', handler);
		};
	}, [source]);

	return (<>
		{iframeLoading && (
			<IframeSkeleton/>
		)}
		<iframe
			ref={iframeRef}
			src={source}
			title={title}
			onLoad={() => {
				setIframeLoading(false);
			}}
			style={{
				height,
				display: iframeLoading ? 'none' : 'block',
				width: '1px',
				minWidth: '100%',
			}}
		/>
	</>
	);
}
